import { Reikwijdte, ReikwijdteValues, trajectenSchema } from "@/entities/dossier-details";
import { z } from "zod";

export const dossierDetailsBaseFields = {
    reikwijdte: z.enum(ReikwijdteValues),
    omschrijving: z.string().trim().nonempty({ error: "Kies een omschrijving." }),
    omschrijvingExtraContext: z.string(),
    stations: z.array(z.string()),
    trajecten: z.array(z.object({ vanStation: z.string(), naarStation: z.string() })),
};

type ReikwijdteRefineData = {
    reikwijdte: Reikwijdte;
    stations: string[];
    trajecten: { vanStation: string; naarStation: string }[];
};

export function applyReikwijdteRefine(data: ReikwijdteRefineData, ctx: z.core.$RefinementCtx) {
    if (data.reikwijdte === Reikwijdte.Stations && data.stations.length === 0) {
        ctx.issues.push({
            code: "custom",
            message: "Voeg minimaal één station toe.",
            path: ["stations"],
            input: data.stations,
        });
    }
    if (data.reikwijdte === Reikwijdte.Trajecten) {
        const result = trajectenSchema.safeParse(data.trajecten);
        if (!result.success) {
            for (const issue of result.error.issues) {
                ctx.issues.push({
                    code: "custom",
                    message: issue.message,
                    path: ["trajecten", ...issue.path],
                    input: data.trajecten,
                });
            }
        }
    }
}
